import { requestHandler } from "../lib/utils/network-client";

export function getCategories(params = {}) {
  return requestHandler("/categories", {
    params
  });
}

export function getCategoryById(id) {
  return requestHandler(`/categories/${id}`);
}

export function createCategory(payload) {
  return requestHandler("/categories", {
    method: "POST",
    body: payload
  });
}

export function updateCategory(id, payload) {
  return requestHandler(`/categories/${id}`, {
    method: "PUT",
    body: payload
  });
}

export function deleteCategory(id) {
  return requestHandler(`/categories/${id}`, {
    method: "DELETE"
  });
}

export function getCategoryBySlugWithProfessors(slug) {
  return requestHandler(`/categories/slug/${slug}`);
}
